import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import type {UpdateWorkoutTemplateInput} from '../ports/workout.repository';
import {WorkoutTemplateIdValidator} from './workout-template-id.validator';

export class UpdateWorkoutTemplateDataValidator
  implements Validator<UpdateWorkoutTemplateInput>
{
  private static readonly templateId = new WorkoutTemplateIdValidator();

  readonly standardSchema = z
    .strictObject({
      templateId: UpdateWorkoutTemplateDataValidator.templateId.standardSchema,
      name: z.string().trim().min(1, 'Name is required.').max(120).optional(),
      notes: z.string().trim().max(4000).nullable().optional(),
    })
    .refine(value => value.name !== undefined || value.notes !== undefined, {
      message: 'Provide a name or notes to update.',
    });

  validate(value: unknown): Result<UpdateWorkoutTemplateInput, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(
        new ValidationError(
          parsed.error.issues[0]?.message ?? 'Invalid update workout template data.',
        ),
      );
    }
    return ok(parsed.data);
  }
}
